import Layout from '../components/Layout';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';
import { UserPlus, ArrowRight } from 'lucide-react';

export default function SignupPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [busy, setBusy] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast({ title: 'Password must be 6+ characters' }); return; }
    setBusy(true);
    try {
      const u = await signup({ ...form, role: 'customer' });
      toast({ title: `Welcome, ${u.name}!`, description: 'Your account is ready.' });
      navigate('/dashboard');
    } catch (err) {
      toast({ title: 'Signup failed', description: err.response?.data?.detail || 'Try again.' });
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="py-16">
        <div className="max-w-md mx-auto px-6">
          <div className="card-soft p-8">
            <div className="w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center mb-5"><UserPlus size={20} /></div>
            <h1 className="h-display text-3xl">Create your account</h1>
            <p className="text-sm text-neutral-500 mt-1">Track your vehicles, orders and service history in one place.</p>

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div><label className="text-xs font-medium">Full name</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <div><label className="text-xs font-medium">Email</label><input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <div><label className="text-xs font-medium">Phone</label><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} required className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" /></div>
              <div><label className="text-xs font-medium">Password</label><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" placeholder="Min 6 characters" /></div>
              <button disabled={busy} type="submit" className="btn-primary w-full justify-center disabled:opacity-60">{busy ? 'Creating...' : 'Create account'} <ArrowRight size={16} /></button>
            </form>

            <p className="mt-6 text-sm text-center text-neutral-600">Already have one? <Link to="/login" className="text-navy font-semibold">Login</Link></p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
